// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen":"_33974c2b58--fullscreen--mfCte","no-print":"_33974c2b58--no-print--WH57H"};